export const PRICE = '23 USD'

export const BRAND = 'Hair Instructor Ready™'

/** Section 2 — interior pages, in upload order. */
export const insidePages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/payD9U7AaYQcDgJWp5xAVW/01_page_29.webp',
    caption: 'Bridal Style Breakdown Map — Page 29',
    label: 'Analyser une référence avant de commencer',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gPTg9bvu9UBNBopX4UqmmK/02_page_13.webp',
    caption: 'Construction du chignon — Page 13',
    label: 'Expliquer chaque étape, de la base à la finition',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/b2BPQeVgyttkEnTTJRVabh/03_page_27.webp',
    caption: 'Challenge : Reverse Analysis — Page 27',
    label: 'Faire analyser un look terminé',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8BmMRG8yVtKkWq4ArrSum9/04_page_19.webp',
    caption: 'Shape Construction Map — Page 19',
    label: 'Décomposer les formes en étapes simples',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/upK53zpuYqDeqoJEQdPVbd/05_page_37.webp',
    caption: 'Activité : Reverse Engineering — Page 37',
    label: 'Des activités prêtes à proposer en cours',
  },
]

/** Section 3 — pain points. */
export const painPoints = [
  {
    title: 'Des heures de préparation',
    text: 'Vous consacrez trop de temps à organiser chaque nouvelle formation.',
  },
  {
    title: 'Des supports dispersés',
    text: 'Vos ressources sont réparties entre plusieurs documents.',
  },
  {
    title: 'Des exercices à créer',
    text: 'Vous devez préparer les activités pratiques de vos élèves.',
  },
  {
    title: 'Des évaluations à organiser',
    text: 'Vous cherchez une méthode claire pour suivre leurs progrès.',
  },
]

/** Section 4 — solution benefits. */
export const solutionBenefits = [
  'Planifier des cours plus facilement.',
  'Expliquer les techniques avec des supports structurés.',
  'Organiser des exercices pratiques.',
  'Évaluer les progrès des élèves.',
]

/** Section 5 — the six volumes. Accent colors match the covers in the mockup. */
export const volumes = [
  {
    number: 1,
    title: 'Fondamentaux de la coiffure & bases professionnelles',
    description: 'Les connaissances essentielles pour construire une base pédagogique solide.',
    accent: '#F3ECE1',
  },
  {
    number: 2,
    title: 'Le système professionnel de coupe',
    description: 'Les principes, techniques et constructions de coupe à transmettre.',
    accent: '#F7CDBE',
  },
  {
    number: 3,
    title: 'Théorie de la couleur & application professionnelle',
    description: 'La colorimétrie, le diagnostic et les applications professionnelles.',
    accent: '#D3E5CC',
  },
  {
    number: 4,
    title: 'Brushing, coiffage & techniques de finition',
    description: 'Les techniques de brushing, de mise en forme et de finition.',
    accent: '#CDE0F1',
  },
  {
    number: 5,
    title: 'Coiffage avancé, chignons & techniques de salon',
    description: 'Les coiffures avancées, les chignons et les techniques de salon.',
    accent: '#DFD0F2',
  },
  {
    number: 6,
    title: 'Boîte à outils du formateur : enseignement & évaluation',
    description:
      'Les ressources pour organiser les cours, accompagner les élèves et évaluer leurs compétences.',
    accent: '#F6E0BC',
  },
]

/** Section 6 — the five bonuses. */
export const bonuses = [
  {
    number: 'Bonus 1',
    title: 'Bibliothèque de plans de cours prêts à enseigner',
    description: 'Pour structurer vos séances pédagogiques.',
    accent: '#F7CDBE',
  },
  {
    number: 'Bonus 2',
    title: 'Bibliothèque d’exercices & fiches pratiques',
    description: 'Pour organiser la pratique de vos élèves.',
    accent: '#D3E5CC',
  },
  {
    number: 'Bonus 3',
    title: 'Kit d’évaluation & de certification',
    description: 'Pour suivre les compétences et préparer des attestations internes.',
    accent: '#CDE0F1',
  },
  {
    number: 'Bonus 4',
    title: 'Atlas visuel pédagogique de la coiffure',
    description: 'Des supports visuels pour expliquer les techniques.',
    accent: '#DFD0F2',
  },
  {
    number: 'Bonus 5',
    title: 'Système de gestion des cours & des élèves',
    description: 'Pour faciliter l’organisation de vos formations.',
    accent: '#F6E0BC',
  },
]

/** Section 7 — before and after. */
export const beforeItems = [
  'Préparer les supports à partir de zéro.',
  'Chercher des ressources dans plusieurs fichiers.',
  'Improviser certaines activités.',
  'Passer des heures à organiser les évaluations.',
]

export const afterItems = [
  'Partir de ressources déjà structurées.',
  'Retrouver les supports au même endroit.',
  'Organiser des activités pratiques.',
  'Utiliser des outils pour évaluer les élèves.',
]

/** Section 8 — who it is for. */
export const audience = [
  'Formatrices en coiffure',
  'Formateurs en coiffure',
  'Enseignants en coiffure',
  'Responsables d’académies',
]

/** Section 9 — what the access includes. */
export const offerIncludes = [
  '6 volumes professionnels',
  '5 bonus pratiques',
  'Ressources numériques en français',
  'Téléchargement après achat',
  'Paiement unique',
]

export const faqs = [
  {
    question: 'Est-ce un produit physique ?',
    answer: 'Non. Il s’agit de ressources numériques à télécharger.',
  },
  {
    question: 'Les ressources sont-elles en français ?',
    answer: 'Oui, cette édition est conçue en français.',
  },
  {
    question: 'À qui s’adresse le système ?',
    answer: 'Aux formateurs, formatrices, enseignants et responsables de formations en coiffure.',
  },
  {
    question: 'Puis-je adapter les ressources à mes cours ?',
    answer:
      'Vous pouvez utiliser les contenus comme supports et adapter leur application à vos formations.',
  },
  {
    question: 'Est-ce adapté aux débutants en coiffure ?',
    answer:
      'Le système est principalement conçu pour les personnes qui enseignent la coiffure, et non comme une formation autonome destinée aux débutants.',
  },
  {
    question: 'Dois-je payer un abonnement ?',
    answer: 'Non, le prix indiqué correspond à un paiement unique.',
  },
  {
    question: 'Le paiement est-il sécurisé ?',
    answer:
      'Oui. Le paiement est sécurisé et crypté, et il est traité automatiquement dans votre devise locale.',
  },
]
